import { Component, OnInit, Input, OnChanges, Output, EventEmitter, ViewChildren, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UserInfo } from './../Models/UserInfo';
import { PHBHPListApiService, PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { ApiService } from 'profile';
import { environment } from 'src/environments/environment';
import { checkLocalizationLang } from 'ph-bhp-feature-packages/ph-bhp-feature-package-sopmanagement/lib/translation.utilities';
import { UserDataService } from 'src/app/services/userData.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfig } from 'src/app/app.config';

@Component({
  selector: 'lib-ph-bhp-user-menu',
  templateUrl: './ph-bhp-user-menu.component.html',
  styleUrls: ['./ph-bhp-user-menu.component.css']
})
export class PhBhpUserMenuComponent implements OnChanges {
  modalRef: BsModalRef;
  modalRef1: BsModalRef;
  public message: string;
  public imagePath;
  UserImage: any;
  imageId: any = null;
  isPreview = false;
  index;
  file;
  public imageData: UserInfo;
  editFlag = true;
  addUpdateFlag = false;
  imageCheck = false;
  imageURL;
  userName;
  @Input() userData;
  @Input() RightNavData: any;
  @ViewChildren('cdkDragList') cdkDragList;
  institutionID: number
  InstitutionsList: Array<any>;
  packageInstitutionsList: Array<any>;
  @Input() institutions: any;
  testImage: string = ""
  itemChange: boolean = false;
  @ViewChild('modelUserName') modelUserName;
  @Output() childData = new EventEmitter();
  updateSubmitted: boolean;
  addimage: boolean
  serverUrl: string;
  serverImage
  htmlToAddTerms
  userprinciplename: string;
  logOutUrl: string;
  constructor(
    private config: AppConfig,
    public service: PHBHPListApiService,
    public layoutService: PHBHPLayoutPackageService,
    private modalService: BsModalService,
    private profileApiService: ApiService,
    private userDataService: UserDataService,
    private router: Router) {
    this.serverUrl = layoutService.serverUrl;
  }
  filename

  ngOnChanges() {
    if (this.userData) {
      //this.currentRoute = this.router.url;
      this.profileApiService.apiUrl = environment.apiUrl+'/api/';
      this.logOutUrl =environment.siteUrl+'login';
      this.userprinciplename = this.userData.externalAppUserId;
      this.firstUpperCase(this.userData.name);
      this.userName = this.userData.name
      // this.service.getUserImageById(this.userData.userId).subscribe((userInfo: UserInfo) => {
      //   if (userInfo) {
      //     this.UserImage = this.serverUrl + userInfo.imageURL;
      //     this.serverImage = this.serverUrl + userInfo.imageURL;
      //   }
      // });
    }

    if(!this.institutions){
      this.institutions = this.config.institutions;
    }

    if (this.institutions && !this.itemChange && this.userData) {
      this.itemChange = true;
      const roleId = this.userData.roleName.roleId
      this.service.getInstitutionsbyId(this.institutions, roleId).subscribe((res: any) => {
        this.InstitutionsList = res;
        this.packageInstitutionsList = [];
        this.InstitutionsList = this.InstitutionsList.filter(inst => roleId > 2 ? inst.institution.status : true);
        this.InstitutionsList.forEach(data => {
          this.packageInstitutionsList.push({
            id: data.institution.institutionID,
            label: data.institution.institutionName
          });
        });
        this.userDataService.institutionsList = this.packageInstitutionsList;
        var selectedInstitution = localStorage.getItem('selectedInstitution');
        if (selectedInstitution) {
          // Not first time login
          var institutionId = parseInt(selectedInstitution);
          var institution = res.find(inst => inst.institution.institutionID == institutionId);
          if (institution) {
            this.institutionChange(institution.institution.institutionID, institution.institution.countryID, institution.institution.groupID);
          } else {
            // Institution not found, do predefined institution (first institution of list)
            if (res.length > 0) {
              this.institutionChange(res[0].institution.institutionID, res[0].institution.countryID, res[0].institution.groupID);
            }
          }
        } else {
          // First time login
          if (this.InstitutionsList.length > 0) {
            this.institutionChange(this.InstitutionsList[0].institution.institutionID, this.InstitutionsList[0].institution.countryID, this.InstitutionsList[0].institution.groupID);
          }
        }

      });
    }
  }

  institutionChange(institutionId, countryId, groupId, goToDashboard = false) {
    this.institutionID = institutionId;
    this.layoutService.institutionID = institutionId;
    this.layoutService.institutionCountryId = countryId;
    this.layoutService.groupID = groupId;
    this.layoutService.institutionIDSubject.next(institutionId);
    this.onInstitutionChange(this.institutionID, goToDashboard);
  }

  sanitizeHTML(str) {
    var temp = document.createElement('div');
    temp.textContent = str;
    return temp.innerHTML;
  }
  preview(files) {

    this.filename = files;
    if (files.length === 0) return;
    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }
    // this.isPreview = true;
    var reader = new FileReader();
    this.imagePath = files;
    // if(this.imagePath[0].size > 25000) {
    //     this.data.showError(this.data.translatetext("Image size should be lesser 25 kb"));
    // }
    reader.readAsDataURL(files[0]);
    reader.onload = _event => {
      this.UserImage = reader.result;
    };
  }
  viewChanges(event){
    switch (event.event) {
      case 'loadInstitution' :
         this.onInstitutionChange(event.value, true);
      break;
      case 'submenuLinkClick' :
        this.childData.emit({ key: 'submenuLinkClick' });
      break;
    }
  }
  upload() {
    if (this.modelUserName.invalid) {
      this.updateSubmitted = true;
      return false;
    }
    //if (this.filename[0].length === 0) return true;
    const formData = new FormData();
    if (this.filename !== undefined) {
      formData.append("ImageURL", this.filename[0]);
    }
    formData.append("ImageURL", this.filename);
    formData.append("name", this.userName);
    formData.append("userId", this.userData.userId)
    this.layoutService.showLoader = true;
    this.service.profileUpdate(this.userData.userId, formData).subscribe((res) => {
      this.layoutService.showLoader = false;
      this.userData.name = this.userName;
      this.serverImage = this.UserImage;
      this.childData.emit({ key: 'imageUpdated', data: this.UserImage })
      this.editFlag = true
    });
  }

  btnHideShow(files) {
    this.editFlag = false;
    this.addUpdateFlag = false;
  }

  firstUpperCase(input) {
    return this.userData.name = input[0].toUpperCase() + input.substr(1);
  }
  logOut() {
    localStorage.removeItem('access_token');
    this.layoutService.institutionID = null;
    this.layoutService.groupID = null;
    //this.data.institutionIDSubject.next(null);
    this.childData.emit({ key: 'logOut' })
  }
  onInstitutionChange(value, goToDashboard) {
    this.institutionID = parseInt(value)
    this.layoutService.institutionID = this.institutionID;
    var institution = this.InstitutionsList.find(inst => inst.institution.institutionID == this.institutionID);
    this.layoutService.institutionWebkess = institution.institution.activateWebKess || false;
    this.layoutService.institutionCountryId = institution.institution.countryID;
    if (institution && institution.institution.groupID) {
      this.layoutService.groupID = institution.institution.groupID;
    } else {
      this.layoutService.groupID = null;
    }
    let lang = checkLocalizationLang(this.layoutService.translate, this.layoutService.translate.currentLang, this.layoutService.institutionCountryId);
    lang = lang ? (lang == 'null' ? 'en': lang) : 'en';
    localStorage.setItem('selectedlanguage', lang);
    this.layoutService.institutionIDSubject.next(this.institutionID);
    localStorage.setItem('selectedInstitution', this.institutionID.toString());
    if(goToDashboard && this.userData.validationKey != 'FirstTimeLogin'){
      this.router.navigate(['/dashboard']);
    }
  }

  cancel() {
    this.editFlag = true;
    this.UserImage = this.serverImage
    this.userName = this.userData.name
  }
  CancelTerms(delmodal) {
    this.modalRef1 = this.modalService.show(delmodal, {
      animated: true,
      backdrop: 'static',
      class: 'w-420'
    });
  }
  deletePolicy() {
    var forceDelete = false;
    this.service.deleteTermsAndconditions(this.userData.userId, forceDelete).subscribe((res: any) => {
      this.modalRef1.hide();
      this.modalRef.hide();
      this.childData.emit({ key: 'logOut' });
    });
  }

  addImage(image) {
    this.editFlag = false;
    if (image != undefined) {
      this.addimage = true;
    }
    else {
      this.addimage = false;
    }
  }

  openTermsandConditions(template) {
    var templateType = "T&C";
    var selectedlanguage = localStorage.getItem('selectedlanguage')
    this.service.getTermsAndconditions(templateType, selectedlanguage).subscribe((res: any) => {
      this.htmlToAddTerms = res.content;
      this.modalRef = this.modalService.show(template, {
        animated: true,
        backdrop: 'static',
        class: 'modal-full termsWidth'
      });
    });
  }

  // getImage() {
  //   var uri = (this.UserImage||this.imageData.userImage)
  //     ? (this.isPreview
  //         ? this.UserImage:this.imageData.userImage)
  //     :'assets/ph-bhp-layout/svg/no-image.png';
  //     return uri;
  // }
  // getDisabled(data) {
  //   this.addUpdateFlag = data;
  // }
}
